module.exports = __webpack_public_path__ + "static/aerial-view-2-e9f94afa42236ef4301df7ef6bb4ee24.jpg";